import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { formatApiErrorDetail } from "../lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/admin");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SiteHeader />
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md bg-white border border-[#E2E8F0] rounded-sm p-8" data-testid="admin-login-card">
          <div className="h-11 w-11 rounded-sm bg-[#0A1128] text-[#D4AF37] inline-flex items-center justify-center">
            <Lock size={18} />
          </div>
          <div className="eyebrow mt-5">Admin portal</div>
          <h1 className="font-display text-2xl md:text-3xl text-[#0A1128] mt-2">Sign in</h1>
          <p className="text-sm text-[#64748B] mt-2">Authorized personnel only.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <div className="text-xs font-medium uppercase tracking-[0.15em] text-[#64748B] mb-2">Email</div>
              <input
                type="email"
                className="pg-input"
                data-testid="admin-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <div className="text-xs font-medium uppercase tracking-[0.15em] text-[#64748B] mb-2">Password</div>
              <input
                type="password"
                className="pg-input"
                data-testid="admin-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {err && <div data-testid="admin-login-error" className="text-sm text-red-600">{err}</div>}
            <button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="btn-gold w-full py-3 rounded-sm text-sm"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
